import { render, staticRenderFns } from "./EntregasDash.vue?vue&type=template&id=fbe9b7da"
import script from "./EntregasDash.vue?vue&type=script&lang=js"
export * from "./EntregasDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports